import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	entitlementFieldPlaceholder: {
		id: 'servicedesk-customer-service-entitlements-field.common.read-view.entitlement-field-placeholder',
		defaultMessage: 'None',
		description: 'Placeholder for entitlement field select when select is in read view.',
	},
});
